import { render, staticRenderFns } from "./Branch-offices-templates.vue?vue&type=template&id=8698b1a4"
import script from "./Branch-offices-templates.vue?vue&type=script&lang=js"
export * from "./Branch-offices-templates.vue?vue&type=script&lang=js"
import style0 from "./Branch-offices-templates.vue?vue&type=style&index=0&id=8698b1a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports